import { Input, Output, OnDestroy, EventEmitter, Component } from '@angular/core';

import { SnActionConfig } from '@lib/ui/actions';

@Component({ template: '' })
export abstract class SnListBaseComponent<Data> implements OnDestroy {
  @Input()
  public items: Data[];

  @Input()
  public actions: SnActionConfig[] = [];

  @Output()
  public readonly itemTap = new EventEmitter<Data>();

  @Output()
  public readonly itemDblTap = new EventEmitter<Data>();

  public ngOnDestroy(): void {
    this.itemTap.complete();
    this.itemDblTap.complete();
  }

  public onItemTap(item: Data): void {
    this.itemTap.emit(item);
  }

  public onItemDblTap(item: Data): void {
    this.itemDblTap.emit(item);
  }

  public abstract trackBy(index: number, item: Data): any;
}
